import { MenuDesign, useFocusNavigation } from '.';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseMenu = props => {
  const focusNavigation = useFocusNavigation(props);
  return /*#__PURE__*/_jsx(MenuDesign, {
    ...props,
    ...focusNavigation
  });
};
//# sourceMappingURL=BaseMenu.js.map